import { withRouter } from 'react-router-dom';
import PromotionManagement from './PromotionManagement';

export default withRouter(PromotionManagement);
